import { createContext, useState } from "react";
import { createCompressorState } from "../components/SingleStageCompressor/SingleStageCompressorEngine";

export const CompressorContext = createContext();

export const CompressorProvider = ({ children }) => {

  const [compressorA] = useState(() => createCompressorState());
  const [compressorB] = useState(() => createCompressorState());
  const [compressorC] = useState(() => createCompressorState());
  const [compressorD] = useState(() => createCompressorState());
  const [compressorE] = useState(() => createCompressorState());
  const [compressorF] = useState(() => createCompressorState());

  return (
    <CompressorContext.Provider value={{
      compressorA,
      compressorB,
      compressorC,
      compressorD,
      compressorE,
      compressorF,
    }}>
      {children}
    </CompressorContext.Provider>
  );
};